import { useContext, useEffect, useState } from "react";
import { createContext } from "react";
import { useGame } from "../GameContext";
import axios from 'axios';

const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
})

const rankingMarketContext = createContext()

export function RankingMarketProvider({ children }) {

    const { activeGame, allGames, industriesBase } = useGame()
    const [loading, setLoading] = useState(false)
    const [rounds, setRounds] = useState([])
    const [marketInActualGame, setMarketInActualGame] = useState([])
    const [rankingInActualGamesFilteredByRound, setRankingInActualGamesFilteredByRound] = useState([])
    const [globalRankingMarket, setGlobalRanking] = useState([])

    const fetchMarketInActualGame = async () => {
        if (marketInActualGame.length > 0) {
            setMarketInActualGame([])
        }
        setLoading(true)
        try {
            const response = await api.get(`/api/supermercado/listar/${activeGame?.jogo}`)
            setMarketInActualGame(response.data)
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    const fetchRoundsInGame = async () => {
        try {
            const response = await api.get(`/api/rodada/listarRodadas/${activeGame?.jogo}`)
            setRounds(response.data)
        } catch (e) {
            console.log(e);
        }
    }

    const structureRankingInCurrentGame = async () => {
        if (rankingInActualGamesFilteredByRound.length > 0) {
            setRankingInActualGamesFilteredByRound([])
        }
        try {
            let allRoundsRanking = []
            for await (const round of rounds) {
                let ranking = []
                for await (const market of marketInActualGame) {
                    const response = await axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/lucroseperdas/obterSupermercadoRodada/${market?.supermercado}/${round?.rodada}`).catch(e => console.log(e))
                    let data = {
                        supermercado: market?.supermercado,
                        nome: market?.nome,
                        receita: 0,
                        cmv: 0,
                        outros: 0,
                        custos: 0,
                        impostos: 0,
                        margemBruta: 0,
                        lucroLiquido: 0
                    }

                    response.data?.forEach(item => {
                        if (item.tipo === "VENDA_SUPERMERCADO") {
                            data.receita += item.total
                        } else if (item.tipo === "COMPRA_SUPERMERCADO") {
                            data.custos += Math.abs(item.total)
                            data.cmv = Math.abs(item.total)
                        } else if (item.tipo === "OUTROS") {
                            data.custos += Math.abs(item.total)
                            data.outros += Math.abs(item.total)
                        }
                    })

                    data.impostos = (10 / 100) * data.receita
                    data.custos += data.impostos
                    data.margemBruta += (data.receita - data.custos)
                    ranking.push(data)
                }
                allRoundsRanking.push(ranking)

            }
            setRankingInActualGamesFilteredByRound(allRoundsRanking)
        } catch (e) {
            console.log(e);
        }
    }

    const setupRankings = async () => {
        try {
            setLoading(true)
            await structureRankingInCurrentGame()
            await structureRankingByAllGames()
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }

    const structureRankingByAllGames = async () => {
        try {
            const globalRanking = []
            const games = allGames.slice(17)
            for await (const game of games) {
                let industries = await api.get(`/api/supermercado/listar/${game?.jogo}`)
                let ranking = []
                for await (const market of industries?.data) {
                    const response = await axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/lucroseperdas/obterSupermercadoJogo/${market?.supermercado}/${game?.jogo}`).catch(e => console.log(e))
                    let data = {
                        supermercado: market?.supermercado,
                        nome: market?.nome,
                        receita: 0,
                        cmv: 0,
                        outros: 0,
                        custos: 0,
                        impostos: 0,
                        margemBruta: 0,
                        lucroLiquido: 0
                    }

                    response.data?.forEach(item => {
                        if (item.tipo === "VENDA_SUPERMERCADO") {
                            data.receita += item.total
                        } else if (item.tipo === "COMPRA_SUPERMERCADO") {
                            data.custos += Math.abs(item.total)
                            data.cmv = Math.abs(item.total)
                        } else if (item.tipo === "OUTROS") {
                            data.custos += Math.abs(item.total)
                            data.outros += Math.abs(item.total)
                        }
                    })

                    data.impostos = (10 / 100) * data.receita
                    data.custos += data.impostos
                    data.margemBruta += (data.receita - data.custos)
                    ranking.push(data)
                }
                globalRanking.push(ranking)
            }

            const globalIndustriesRanking = globalRanking.flat().reduce((acc, item) => {
                if (acc?.length === 0) {
                    acc?.push(item)
                    return acc
                }
                const findIndex = acc?.findIndex(element => element.nome === item.nome)

                if (findIndex > -1) {
                    acc[findIndex].receita += item.receita
                    acc[findIndex].margemBruta += item.margemBruta
                    acc[findIndex].lucroLiquido += item.lucroLiquido
                    return acc
                }
                acc?.push(item)
                return acc
            }, [])

            setGlobalRanking(globalIndustriesRanking.sort((a, b) => {
                if (a.margemBruta > b.margemBruta) {
                    return -1
                }
                if (a.margemBruta < b.margemBruta) {
                    return 1
                }
                return 0
            }))

        } catch (e) {
            console.log(e);
        }
    }

    // useEffect(() => {
    //     structureRankingByAllGames()
    // }, [allGames])

    return (
        <rankingMarketContext.Provider
            value={{
                rankingInActualGamesFilteredByRound,
                structureRankingInCurrentGame,
                setupRankings,
                setRankingInActualGamesFilteredByRound,
                fetchMarketInActualGame,
                fetchRoundsInGame,
                setMarketInActualGame,
                setRounds,
                rounds,
                loading,
                marketInActualGame,
                globalRankingMarket
            }}
        >
            {children}
        </rankingMarketContext.Provider>
    )
}

export const useRankingMarketPlace = () => useContext(rankingMarketContext);